import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

export default class Accordion {
  constructor(root) {
    this.root = root;
    this.button = root.querySelector('[aria-expanded]');
    this.panel = root.querySelector(`#${this.button.getAttribute('aria-controls')}`);
    this.isOpen = this.button.getAttribute('aria-expanded') === 'true';

    this.init();
  }

  init() {
    this.panel.hidden = !this.isOpen;
    this.panel.setAttribute('role', 'region');
    this.panel.setAttribute('aria-labelledby', this.button.id);

    this.button.addEventListener('click', this.handleClick);
  }

  handleClick = () => {
    this.isOpen ? this.close() : this.open();
    ScrollTrigger.refresh(true);
  };

  handleOnTransitionend = () => {
    this.panel.hidden = true;
  };

  open() {
    this.panel.hidden = false;
    this.panel.offsetHeight; // force reflow so the panel transition happens after hidden has changed
    this.button.setAttribute('aria-expanded', true);

    this.isOpen = true;
  }

  close() {
    this.button.setAttribute('aria-expanded', false);
    this.panel.addEventListener('transitionend', this.handleOnTransitionend, { once: true });

    this.isOpen = false;
  }
}
